import { render } from "./AuthorizationSostenedor.vue?vue&type=template&id=5a7d55f6"
import script from "./AuthorizationSostenedor.vue?vue&type=script&lang=js"
export * from "./AuthorizationSostenedor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/isaias/Developer/Trayectics/Trayectics-Questions/trayectics_questions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__